// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3nTpE","name":"ConsentHeader_name__2Gk7I","birthday":"ConsentHeader_birthday__qfTg3","skeleton":"ConsentHeader_skeleton__1tg61"};